export const ping = async () => {
  const result = await fetch(`${process.env.NEXT_PUBLIC_AUTH_ENDPOINT as string}/ping`, {});
  return result;
};
